const weekday = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
var myMonths=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
function getDateString(dt) {
  return dt.getDate() + '-' + 
    ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][dt.getMonth()] + 
    '-' + dt.getFullYear();
}

// Converts a date into 'July 2010' format
function getMonthYearString(dt) {
  return ['January','February','March','April','May','June','July',
          'August','September','October','November','December'][dt.getMonth()] +
         ' ' + dt.getFullYear();
}

window.addEventListener('load', (event) => {
  var today = new Date();
    var nowTime = today.getHours();
  // Get CST Time
  var utc = today.getTime() + (today.getTimezoneOffset() * 60000);
  var nd = new Date(utc + (3600000 * -5));
  var cst = nd.getHours();
});

// This is the function called when the user clicks any button
function chooseDate(e) {

 $(".product-actions__add-to-cart-button").prop("disabled", false);
$('.custom_date_picker').addClass('active');
  var targ; // Crossbrowser way to find the target (http://www.quirksmode.org/js/events_properties.html)
	if (!e) var e = window.event;
	if (e.target) targ = e.target;
	else if (e.srcElement) targ = e.srcElement;
	if (targ.nodeType == 3) targ = targ.parentNode; // defeat Safari bug

  var div = targ.parentNode.parentNode.parentNode.parentNode.parentNode; // Find the div
  var idOfTextbox = div.getAttribute('datepickertextbox'); // Get the textbox id which was saved in the div
  var textbox = document.getElementById(idOfTextbox); // Find the textbox now
  if (targ.value=='<' || targ.value=='>') { // Do they want the change the month?
    createCalendar(div, new Date(targ.getAttribute('date')));
    return;
  }


if(targ.classList.contains('today')){
  var today = new Date();
  var nowTime = today.getHours();
$('.time_slot').each(function() {
  var dataTime = $(this).attr('data');
  if (dataTime <= nowTime) {
    $(this).hide(); 
  } else {
    $(this).show(); 
  }
});
  if(targ.getAttribute('date-day') == 'Friday'){
  $('.hide-slot').hide();
  }
}else{
  $('.time_slot').show();
  if(targ.getAttribute('date-day') == 'Friday'){
  $('.hide-slot').hide();
  }else{
  $('.hide-slot').show();
  }
}
 



//console.log(targ.getAttribute('date-day'));
$('.custom_datepicker_bottom .day').text(targ.getAttribute('date-day'));
var checkDate = targ.value * 1; 
if(checkDate < 10){
checkDate = '0'+ checkDate;
}
var checkedMonth = targ.getAttribute('date-month');
$('.datepickerdropdown table input[type=button]').removeClass('active');
$(e.target).addClass('active');
$('.custom_datepicker_date').text(checkDate);
$('.custom_datepicker_top .month').text(checkedMonth);
// var calMonth = $('[colspan="5"] input').val();
// console.log('--'+checkedMonth+'--');
// console.log('--'+calMonth+'--');
$('[colspan="5"] input').val(checkedMonth);
// if(checkedMonth == calMonth){
// alert();
// }


  textbox.value = targ.getAttribute('date'); // Set the selected date
 
// div.parentNode.removeChild(div); // Remove the dropdown box now
  
//   alert(targ.getAttribute('date'));
  localStorage.setItem('temp-day', targ.getAttribute('date'));
  $('#deliveryDate').val(targ.getAttribute('date'));
   $('#inlineRadioCal').prop('checked', true);
}

// Parse a date in d-MMM-yyyy format
function parseMyDate(d) {
  if (d=="") return new Date('NotADate'); // For Safari
  var a = d.split('-');
  if (a.length!=3) return new Date(d); // Missing 2 dashes
  var m = -1; // Now find the month
  if (a[1]=='Jan') m=0;
  if (a[1]=='Feb') m=1;
  if (a[1]=='Mar') m=2;
  if (a[1]=='Apr') m=3;
  if (a[1]=='May') m=4;
  if (a[1]=='Jun') m=5;
  if (a[1]=='Jul') m=6;
  if (a[1]=='Aug') m=7;
  if (a[1]=='Sep') m=8;
  if (a[1]=='Oct') m=9;
  if (a[1]=='Nov') m=10;
  if (a[1]=='Dec') m=11;
  if (m<0) return new Date(d); // Couldn't find the month
  return new Date(a[2],m,a[0],0,0,0,0);
}

// This creates the calendar for a given month
function createCalendar(div, month) {
  var idOfTextbox = div.getAttribute('datepickertextbox'); // Get the textbox id which was saved in the div
  var textbox = document.getElementById(idOfTextbox); // Find the textbox now
  var tbl = document.createElement('table');
  var topRow = tbl.insertRow(-1);
  var td = topRow.insertCell(-1);
  var lastMonthBn = document.createElement('input');
  lastMonthBn.type='button'; // Have to immediately set the type due to IE
  td.appendChild(lastMonthBn);
  lastMonthBn.value='<';
  lastMonthBn.id="lastMonthBn";
  lastMonthBn.onclick=chooseDate;
  lastMonthBn.setAttribute('date',new Date(month.getFullYear(),month.getMonth()-1,1,0,0,0,0).toString());


  var td = topRow.insertCell(-1);
  td.colSpan=5;
  var mon = document.createElement('input');
  mon.type='text';
  td.appendChild(mon);
  mon.value = myMonths[month.getMonth()];
  mon.size=15;
  mon.disabled='disabled';
  var td = topRow.insertCell(-1);
  var nextMonthBn = document.createElement('input');
  nextMonthBn.type='button';
  td.appendChild(nextMonthBn);
  nextMonthBn.value = '>';
  nextMonthBn.id = 'nextMonthBn';
  nextMonthBn.onclick=chooseDate;
  nextMonthBn.setAttribute('date',new Date(month.getFullYear(),month.getMonth()+1,1,0,0,0,0).toString());
  var daysRow = tbl.insertRow(-1);
  daysRow.insertCell(-1).innerHTML="Mon";
  daysRow.insertCell(-1).innerHTML="Tue";
  daysRow.insertCell(-1).innerHTML="Wed";
  daysRow.insertCell(-1).innerHTML="Thu";
  daysRow.insertCell(-1).innerHTML="Fri";
  daysRow.insertCell(-1).innerHTML="Sat";
  daysRow.insertCell(-1).innerHTML="Sun";
  
  // Make the calendar
  var selected = parseMyDate(textbox.value); // Try parsing the date
  var today = new Date();
  var nowTime = today.getHours();
  // Get CST Time
  var utc = today.getTime() + (today.getTimezoneOffset() * 60000);
  var nd = new Date(utc + (3600000 * -5));
  var cst = nd.getHours();
  
  date = new Date(month.getFullYear(),month.getMonth(),1,0,0,0,0); // Starting at the 1st of the month
console.log(date);
  var extras = (date.getDay() + 6) % 7; // How many days of the last month do we need to include?
console.log(extras);
  date.setDate(date.getDate()-extras); // Skip back to the previous monday
console.log(date);
  while (1) { // Loop for each week
    var tr = tbl.insertRow(-1);
    tr.classList.add("cal-tr");
    for (i=0;i<7;i++) { // Loop each day of this week
      var td = tr.insertCell(-1);
      var inp = document.createElement('input');
      inp.type = 'button';
      td.appendChild(inp);
      inp.value = date.getDate();
      inp.onclick = chooseDate;

     // console.log(weekday[date.getDay()]);
      inp.setAttribute('date-day',weekday[date.getDay()]);
      inp.setAttribute('date-month',myMonths[date.getMonth()]);
      inp.setAttribute('date',getDateString(date));
//       if (date.getMonth() != month.getMonth()) {
//         if (inp.className) inp.className += ' ';
//         inp.className+='othermonth';
//       }

      if(date < today ) {
//      	if(date < Date("2021-12-12")) {
      	if (inp.className) inp.className += ' ';
        inp.className+='othermonth';
        inp.setAttribute("disabled", "");
      }


      if (date.getDate()==today.getDate() && date.getMonth()==today.getMonth() && date.getFullYear()==today.getFullYear()) {
        if (inp.className) inp.className += ' ';
        inp.className+='today';
             
//console.log(nowTime);
         if(nowTime < 18) {
            inp.classList.remove("othermonth");
        	inp.removeAttribute("disabled");
         }

      }
      if (!isNaN(selected) && date.getDate()==selected.getDate() && date.getMonth()==selected.getMonth() && date.getFullYear()==selected.getFullYear()) {
        if (inp.className) inp.className += ' ';
        inp.className+='selected';
      }
      
      date.setDate(date.getDate()+1); // Increment a day
    }
console.log(date.getDate());
// console.log(date.getMonth());
// console.log(month.getMonth());
    // We are done if we've moved on to the next month
    if (date.getMonth() != month.getMonth() && date.getDate() > 9) {
      break;
    }
  }
  
  // At the end, we do a quick insert of the newly made table, hopefully to remove any chance of screen flicker
  if (div.hasChildNodes()) { // For flicking between months
    div.replaceChild(tbl, div.childNodes[0]);
  } else { // For creating the calendar when they first click the icon
    div.appendChild(tbl);
  }
}

// This is called when they click the icon next to the date inputbox
function showDatePicker(idOfTextbox) {

$('.datepicker-modal').addClass('is-visible');
  var textbox = document.getElementById(idOfTextbox);
  
  // See if the date picker is already there, if so, remove it
  x = textbox.parentNode.getElementsByTagName('div');
  for (i=0;i<x.length;i++) {
    if (x[i].getAttribute('class')=='datepickerdropdown') {
      textbox.parentNode.removeChild(x[i]);
      return false;
    }
  }

  // Grab the date, or use the current date if not valid
  var date = parseMyDate(textbox.value);
  if (isNaN(date)) date = new Date();

  // Create the box
  var div = document.createElement('div');
  div.className='datepickerdropdown';
  div.id='pd_datepicker';
  div.setAttribute('datepickertextbox', idOfTextbox); // Remember the textbox id in the div
  createCalendar(div, date); // Create the calendar
  $('.datepicker-content').append(div, textbox); // Add the box to screen just after the textbox 

  return false;
}

// Adds an item after an existing one
function insertAfter(newItem, existingItem) {
console.log('newItem',newItem);
  if (existingItem.nextSibling) { // Find the next sibling, and add newItem before it
    existingItem.parentNode.insertBefore(newItem, existingItem.nextSibling); 
  } else { // In case the existingItem has no sibling after itself, append it
    existingItem.parentNode.appendChild(newItem);
  }
}

// This is called when the page loads, it searches for inputs where the class is 'datepicker'
function datePickerInit() {
  // Search for elements by class
  // var allElements = document.getElementsByTagName("*");
  // for (i=0; i<allElements.length; i++) {
  //   var className = allElements[i].className+'';
  //   if (className=='datepicker' || className.indexOf('datepicker ') != -1 || className.indexOf(' datepicker') != -1) {
  //     // Found one! Now lets add a datepicker next to it  
  //     var a = document.createElement('a');
  //     a.href='#';
  //     a.className="datepickershow"
  //     a.setAttribute('onclick','return showDatePicker("' + allElements[i].id + '")');
  //     var img = document.createElement('img');
  //     img.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABGdBTUEAAK/INwWK6QAAABh0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjM2qefiJQAAAdtJREFUOE+Vj+9PUnEUxvPvar3xja96Q1hGEKG0ubZqbfHCNqIVA4eYLAwFp0LYD4iIJEdeRGGZwDAEcUOn9oNIvPcGgjBQfHE69/YFihe1zs59du7d83nOuR0AcOq/CgEqWbaHDqaD+clF1rLAmija6MsZ5vb0s9nB1xm168s9x67y6Y7q2TaXjo8tVKjUTv7Zt61pAkwt/UA3zFwFuxysV2BKAuYeMAnBcBaGukDdCaozaLg5sUGAiQDLA3IIDIBfAfO34N118PaDRwYvRfBcCMrTaLg2liTAOEW3NjzpBZsMpqUwKQaLCMYvwGMhjArQIDfGCTDqy3EAX47lfVTnCo3qCnOzJ8IpW6pJR2IEGHn7/bBaR5MLO8y8CtPuKO2J0nMfGdKr+5uZ4kVdhAD6N99K1bo7ynB5vHpj3AZ0NxWBbs0KAbTur8VKfTbGeFcbkc1sfnBHuA1CzTIB7js/H5SPffFW3q9sau2PDdLhxkl3X+wiQCVYf4Jt3h1Itmb8iBvEusZJd2a2CuXjxXUWU5dSnAZ5/b0QkOobgMKWzh8eMcXaXr6aYSqfcuXtbAkdbS3RfSD/MGDfvGFO9ZuSfY/ilx/GLumi57Vhgfp9W597ECJA2/a/v/4ENLpYKsDo3kgAAAAASUVORK5CYII=';
  //     img.title='Show calendar';
  //     a.appendChild(img);
  //     //insertAfter(a, allElements[i]);

  //   }
  // }
}

if (window.addEventListener) { // W3C standard
  window.addEventListener('load', datePickerInit, false);
} else if (window.attachEvent) { // Microsoft
  window.attachEvent('onload', datePickerInit);
}


function closeDatepicker(){
$('.datepicker-modal').removeClass('is-visible');
$('.datepickerdropdown').remove();
}

$(document).on('click', '.time_slot', function() {
 $('.custom_datepicker_bottom .time').text($(this).find('input').val());
$('#shipping-slot').val($(this).find('input').val());
$('.datepicker-modal').removeClass('is-visible');
$('.datepickerdropdown').remove();
});


$(document).on("click",".product_action_btn a",function(event){  
      event.preventDefault();
    var product_id = $(this).attr('data-id');
$(product_id).show();
$('.product_model').addClass('open');
$('.product_model .modal-first').hide();
});
$(document).on("click",".product_model.open .modal-close",function(event){ 
 event.preventDefault(); 
$('.product_model .modal-first').show();
   $('.product_model').removeClass('open');
  $('.product_model .modal-second').hide();
});
$(document).on("click",".product_model .modal-close",function(event){ 
 event.preventDefault(); 
$('.product_model').removeClass('is-visible');
});
$(document).on("click",".product_model .continue_button",function(event){ 
 event.preventDefault(); 
$('.product_model').removeClass('is-visible');
});
